/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { userSelector } from '@/stores/slices/user';
import AppUtil from '@/utils/AppUtil';
import { Tooltip, Button } from 'antd';
import classnames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Worker } from '@/generated/graphql';
import useFeatureFlag from '@/hooks/useFeatureFlag';
import useDepartment from '@/hooks/useDepartment';
import ReplayRunPopup from './ReplayRunPopup';
import ReplayIcon from '../icons/ReplayIcon';
import styles from './ReplayRun.module.less';

interface ReplayRunProps {
  worker: Worker;
  isRunPage: boolean;
  isMiniPlayground: boolean;
}

const ReplayRun = (props: ReplayRunProps) => {
  const { worker, isRunPage, isMiniPlayground } = props;
  const { username } = useSelector(userSelector);
  const isSupportUser = AppUtil.isSupportUser(username);
  const { department } = useDepartment();
  const [{ rolloutReplayUi }] = useFeatureFlag({
    context: { department: { key: department.id, dept_id: department.id } }
  });

  const [popupOpen, setPopupOpen] = useState(false);

  if (
    !isSupportUser ||
    !isRunPage ||
    !worker?.id ||
    isMiniPlayground ||
    !rolloutReplayUi
  ) {
    return null;
  }

  return (
    <>
      <Tooltip title="Replay run">
        <Button
          type="text"
          shape="default"
          data-cy="worker-dry-run"
          className={classnames(
            'display-flex',
            'align-center',
            'justify-center',
            styles.button
          )}
          onClick={() => setPopupOpen(true)}
        >
          <ReplayIcon className={styles.replayRunIcon} />
        </Button>
      </Tooltip>
      <ReplayRunPopup
        workerId={worker.id}
        visible={popupOpen}
        onClose={() => setPopupOpen(false)}
      />
    </>
  );
};

export default ReplayRun;
